<div class="ui-g-12">

  <div class="ui-g">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
      <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [options]="indicator.options"></app-infobox>
    </div>
  </div>

  <div class="ui-g-12 ui-md-12 ui-sm-12"  *ngIf="data != null">
    <h2>{{ translations.categoryInvestmentTypePromo | translate }}</h2>
    <div class="chart-container">
      <chart [options]="categoryInvestmentTypePromo.options"
             (load)="setChartInstance(categoryInvestmentTypePromo, $event.context)"></chart>
    </div>
  </div>

  <div class="ui-g-12 ui-md-12 ui-sm-12"  *ngIf="data != null">
    <h2>{{ translations.categoryDiscountAverage | translate }}</h2>
    <div class="chart-container">
      <chart [options]="categoryDiscountAverage.options"
             (load)="setChartInstance(categoryDiscountAverage, $event.context)"></chart>
    </div>
  </div>

  <div class="ui-g-12 ui-md-12 ui-sm-12"  *ngIf="data != null">
    <h2>{{ translations.categoryPromoPressure | translate }}</h2>
    <div class="chart-container">
      <chart [options]="categoryPromoPressure.options"
             (load)="setChartInstance(categoryPromoPressure, $event.context)"></chart>
    </div>
  </div>

  <div class="ui-g-12 ui-md-12 ui-sm-12" *ngIf="data != null">
    <p-table [value]="datatableCategory" class="overview-table">

      <ng-template pTemplate="header">
        <tr>
          <th [pSortableColumn]="'nomePromo'">
            <span class="sortableCol">{{ translations.nomePromo | translate }}</span>
            <p-sortIcon class="sortableIcon" [field]="'nomePromo'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'typePromo'">
            <span class="sortableCol">{{ translations.typePromo | translate }}</span>
            <p-sortIcon class="sortableIcon" [field]="'typePromo'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'startPromo'">
            <span class="sortableCol">{{ translations.startPromo | translate }}</span>
            <p-sortIcon class="sortableIcon" [field]="'startPromo'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'endPromo'">
            <span class="sortableCol">{{ translations.endPromo | translate }}</span>
            <p-sortIcon class="sortableIcon" [field]="'endPromo'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'investmentPromo'">
            <span class="sortableCol">{{ translations.investmentPromo | translate }}</span>
            <p-sortIcon class="sortableIcon" [field]="'investmentPromo'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'associatedExpensePromo'">
            <span class="sortableCol">{{ translations.associatedExpensePromo | translate }}</span>
            <p-sortIcon class="sortableIcon" [field]="'associatedExpensePromo'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'averageDiscountPromo'">
            <span class="sortableCol">{{ translations.averageDiscountPromo | translate }}</span>
            <p-sortIcon class="sortableIcon" [field]="'averageDiscountPromo'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'promotionalPressurePromo'">
            <span class="sortableCol">{{ translations.promotionalPressurePromo | translate }}</span>
            <p-sortIcon class="sortableIcon" [field]="'promotionalPressurePromo'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'numberReceiptsPromo'">
            <span class="sortableCol">{{ translations.numberReceiptsPromo | translate }}</span>
            <p-sortIcon class="sortableIcon" [field]="'numberReceiptsPromo'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quantityPromo'">
            <span class="sortableCol">{{ translations.quantityPromo | translate }}</span>
            <p-sortIcon class="sortableIcon" [field]="'quantityPromo'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'adhesionPromo'">
            <span class="sortableCol">{{ translations.adhesionPromo | translate }}</span>
            <p-sortIcon class="sortableIcon" [field]="'adhesionPromo'"></p-sortIcon>
          </th>
        </tr>
      </ng-template>



      average discount

      associated expense

      <ng-template pTemplate="body" let-col>
        <tr>
          <td class="number-column">{{ col.nomePromo }}</td>
          <td class="number-column">{{ col.typePromo }}</td>
          <td class="number-column">{{ convertData (col.startPromo) }}</td>
          <td class="number-column">{{ convertData (col.endPromo) }}</td>
          <td class="number-column">{{ col.investmentPromo | numberKM }}€</td>
          <td class="number-column">{{ col.associatedExpensePromo | numberKM }}€</td>
          <td class="number-column">{{ col.averageDiscountPromo | formatNumber:2 }} %</td>
          <td class="number-column">{{ col.promotionalPressurePromo | formatNumber:2 }} %</td>
          <td class="number-column">{{ col.numberReceiptsPromo | numberKM }}</td>
          <td class="number-column">{{ col.quantityPromo | numberKM }}</td>
          <td class="number-column">{{ col.adhesionPromo | formatNumber:2 }} %</td>
        </tr>
      </ng-template>

    </p-table>

  </div>

  <p-dialog header="Error" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
    <p>{{ 'store.selectOneErrorMsg' | translate }}</p>
    <div class="ui-dialog-footer">
      <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
    </div>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/overview/overview-products/overview-products.component.html